<script setup>
import WizardSummaryField from "@/components/wizard/WizardSummaryField.vue";
import WizardSummary from "@/components/wizard/WizardSummary.vue";
import {pgettext} from "@/utils/translate";
import {mdiPencil} from "@mdi/js";

const props = defineProps({
    isEditing: {
        type: Boolean,
        default: false,
    },
    patientId: {
        type: [Number, String],
    },
    tic: {
        type: String,
        required: true,
    },
    formData: {
        type: Object,
        required: true,
    },
    isSubmitting: {
        type: Boolean,
        default: false,
    },
});
const emit = defineEmits(['pushStep', 'submit']);

function goToStep(stepName) {
    emit('pushStep', stepName);
}

function submit() {
    emit('submit', props.formData);
}

</script>

<template>
    <main>
        <h1>{{ pgettext('title', 'Summary') }}</h1>

        <v-alert v-if="patientId && isEditing" type="info" variant="tonal" class="mb-8">
            <strong>
                {{
                    interpolate(gettext('You are editing patient TIC %(tic)s.'), {tic})
                }}
            </strong>
        </v-alert>

        <div class="text-center mb-6">
            <v-btn @click="goToStep('hospitalRecords')" :prepend-icon="mdiPencil">
                {{ pgettext('action', 'Edit') }}
            </v-btn>
        </div>
        <div class="d-flex justify-center">
            <WizardSummary vertical>
                <WizardSummaryField :title="pgettext('label', 'Temporary Identifier')" disableEdit>
                    {{ formData.temporaryIdentifier }}
                </WizardSummaryField>

                <WizardSummaryField :title="pgettext('label', 'Admitted to Hospital Timestamp')" disableEdit>
                    <template v-if="formData.admittedToHospitalTimestamp">
                        {{ formatShortDateTime(formData.admittedToHospitalTimestamp) }}
                    </template>
                </WizardSummaryField>

                <WizardSummaryField :title="pgettext('label', 'Destination Ward')" disableEdit>
                    {{ formData.destinationWard }}
                </WizardSummaryField>
            </WizardSummary>
        </div>

        <div class="text-center mt-8">
            <v-btn @click="submit()" color="green" size="large" :loading="isSubmitting">
                <strong>{{ pgettext('action', 'Save') }}</strong>
            </v-btn>
        </div>
    </main>
</template>
